import { DataSource } from '@angular/cdk/collections';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { map } from 'rxjs/operators';
import { Observable, of as observableOf, merge } from 'rxjs';

// TODO: Replace this with your own data model type

export interface TableContratosItem {
  numero: string;
  aplicacion: string;
  usuarios_permitidos?: string;
  tipo_contrato?: string;
  fecha_inicio?: string;
  fecha_fin: string;
  acciones?: ActionsItem[];
}

export interface ActionsItem {
  onlyIcon?: true,
  icon?: string;
  name?: string;
  function: string;
  params?: string;
}

// TODO: replace this with real data from your application
const EXAMPLE_DATA: TableContratosItem[] = [
  {
    numero: '123',
    aplicacion: 'Cookial',
    usuarios_permitidos: '33',
    tipo_contrato: 'Termino fijo',
    fecha_inicio: '20-03-2019',
    fecha_fin: '20-03-2019',
    acciones: [
      {
        onlyIcon: true,
        icon: 'edit',
        function: 'Editar'
      }
    ]
  }
];

/**
 * Data source for the TableContratos view. This class should
 * encapsulate all logic for fetching and manipulating the displayed data
 * (including sorting, pagination, and filtering).
 */
export class TableContratosDataSource extends DataSource<TableContratosItem> {
  data: TableContratosItem[] = EXAMPLE_DATA;
  paginator: MatPaginator;
  sort: MatSort;

  constructor() {
    super();
  }

  /**
   * Connect this data source to the table. The table will only update when
   * the returned stream emits new items.
   * @returns A stream of the items to be rendered.
   */
  connect(): Observable<TableContratosItem[]> {
    // Combine everything that affects the rendered data into one update
    // stream for the data-table to consume.
    const dataMutations = [
      observableOf(this.data),
      this.paginator.page,
      this.sort.sortChange
    ];

    return merge(...dataMutations).pipe(map(() => {
      return this.getPagedData(this.getSortedData([...this.data]));
    }));
  }

  /**
   *  Called when the table is being destroyed. Use this function, to clean up
   * any open connections or free any held resources that were set up during connect.
   */
  disconnect() {}

  /**
   * Paginate the data (client-side). If you're using server-side pagination,
   * this would be replaced by requesting the appropriate data from the server.
   */
  private getPagedData(data: TableContratosItem[]) {
    const startIndex = this.paginator.pageIndex * this.paginator.pageSize;
    return data.splice(startIndex, this.paginator.pageSize);
  }

  /**
   * Sort the data (client-side). If you're using server-side sorting,
   * this would be replaced by requesting the appropriate data from the server.
   */
  private getSortedData(data: TableContratosItem[]) {
    if (!this.sort.active || this.sort.direction === '') {
      return data;
    }

    return data.sort((a, b) => {
      const isAsc = this.sort.direction === 'asc';
      switch (this.sort.active) {
        case 'numero': return compare(a.numero, b.numero, isAsc);
        case 'aplicacion': return compare(+a.aplicacion, +b.aplicacion, isAsc);
        case 'usuarios_permitidos': return compare(+a.usuarios_permitidos, +b.usuarios_permitidos, isAsc);
        case 'tipo_contrato': return compare(+a.tipo_contrato, +b.tipo_contrato, isAsc);
        case 'fecha_inicio': return compare(+a.fecha_inicio, +b.fecha_inicio, isAsc);
        case 'fecha_fin': return compare(+a.fecha_fin, +b.fecha_fin, isAsc);
        default: return 0;
      }
    });
  }
}

/** Simple sort comparator for example ID/Name columns (for client-side sorting). */
function compare(a: string | number, b: string | number, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
